import React from 'react';
import { Navigate } from 'react-router-dom';

const isAuthenticated = () => {
  try {
    const authData = JSON.parse(localStorage.getItem('authData') || '{}');
    return !!authData?.token || !!authData?.accessToken;
  } catch (error) {
    console.error('Auth check error:', error);
    return false;
  }
};

const isAdminUser = () => {
  try {
    const authData = JSON.parse(localStorage.getItem('authData') || '{}');
    return authData?.user?.role === 'admin';
  } catch (error) {
    console.error('Admin check error:', error);
    return false;
  }
};

export const PublicRoute = ({ children }) => {
  const auth = isAuthenticated();
  
  if (auth) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

export const PrivateRoute = ({ children }) => {
  const auth = isAuthenticated();

  if (!auth) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

export const AdminRoute = ({ children }) => {
  const auth = isAuthenticated();

  if (!auth) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdminUser()) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export const UserOnlyRoute = ({ children }) => {
  const auth = isAuthenticated();

  if (!auth) {
    return <Navigate to="/login" replace />;
  }

  if (isAdminUser()) {
    return <Navigate to="/manage-portal" replace />;
  }

  return children;
};
